import { useAddressService } from './useAddressService';
import { useCallback } from 'react';

type FetchPostalCodeSuggestionsProps = {
  countryISO?: string;
  limit: number;
};

export function useFetchPostalCodeSuggestions({
  countryISO,
  limit,
}: FetchPostalCodeSuggestionsProps): (searchTerm: string) => Promise<string[]> {
  const { addressService } = useAddressService();
  return useCallback(
    async (searchTerm: string) => {
      if (!countryISO) return [];
      const result = await addressService.autoCompleteCities({
        countryISO,
        limit,
        key: searchTerm,
      });
      return result.Cities.map((city) => city.PostalCode)
        .filter(distinct)
        .sort();
    },
    [addressService, countryISO, limit]
  );
}

function distinct<T>(value: T, index: number, array: Array<T>): boolean {
  return array.indexOf(value) === index;
}
